// extracted by mini-css-extract-plugin
export default {"summaryDetailWithStatusPanel":"_35UAbqSAPMsI4jvo-Ocd7Z"};